import { PeriodProvider } from '@/app/context/PeriodContext';
import PeriodInitializer from '@/components/periodDetails/PeriodInitializer';
import BuildingsTotal from '@/pages/buildingsTotal';
import ConfigureExpenses from '@/pages/configureExpenses';
import EnableSharingType from '@/pages/enableSharingType';
import PersonProductRoles from '@/pages/personProductRoles';
import Projects from '@/pages/projects';
import Redirect from '@/pages/redirecting';
import SharingDetail from '@/pages/sharingDetail';
import { PAGE_PATHS, PAGE_ROLES } from '@app/constants/pages';
import RequireAuth from '@features/auth/RequireAuth';
import RequireLogin from '@features/auth/RequireLogin';
import Buildings from '@pages/buildings';
import Expenses from '@pages/expenses';
import Layout from '@pages/layout';
import Login from '@pages/login';
import Process from '@pages/process';

import { Route, Routes } from 'react-router-dom';

function AppRoute() {
  return (
    <PeriodProvider>
      <Routes>
        <Route path={PAGE_PATHS.LOGIN} element={<Login />} />
        <Route element={<RequireLogin />}>
          <Route element={<PeriodInitializer />}>
            <Route element={<Layout />}>
              <Route path={PAGE_PATHS.ROOT} element={<Redirect />} />

              <Route>
                <Route element={<RequireAuth roles={PAGE_ROLES.BUILDINGS} />}>
                  <Route path={PAGE_PATHS.BUILDINGS} element={<Buildings />} />
                </Route>

                <Route element={<RequireAuth roles={PAGE_ROLES.EXPENSES} />}>
                  <Route path={PAGE_PATHS.EXPENSES} element={<Expenses />} />
                </Route>

                <Route element={<RequireAuth roles={PAGE_ROLES.PROJECTS} />}>
                  <Route path={PAGE_PATHS.PROJECTS} element={<Projects />} />
                </Route>
                <Route element={<RequireAuth roles={PAGE_ROLES.BUILDINGS_TOTAL} />}>
                  <Route path={PAGE_PATHS.BUILDINGS_TOTAL} element={<BuildingsTotal />} />
                </Route>
                <Route element={<RequireAuth roles={PAGE_ROLES.SHARING_DETAIL} />}>
                  <Route path={PAGE_PATHS.SHARING_DETAIL} element={<SharingDetail />} />
                </Route>
              </Route>

              <Route element={<RequireAuth roles={PAGE_ROLES.PROCESS} />}>
                <Route path={PAGE_PATHS.PROCESS} element={<Process />} />
              </Route>
              <Route element={<RequireAuth roles={PAGE_ROLES.CONFIGURE_EXPENSES} />}>
                <Route path={PAGE_PATHS.CONFIGURE_EXPENSES} element={<ConfigureExpenses />} />
              </Route>

              <Route element={<RequireAuth roles={PAGE_ROLES.PERMISSIONS} />}>
                <Route>
                  <Route path={PAGE_PATHS.ENABLE_ALLOCATION_TYPE} element={<EnableSharingType />} />
                </Route>
                <Route path={PAGE_PATHS.PERMISSIONS} element={<PersonProductRoles />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </PeriodProvider>
  );
}

export default AppRoute;
